import { render, staticRenderFns } from "./importations.vue?vue&type=template&id=06f25ef4&"
import script from "./importations.vue?vue&type=script&lang=js&"
export * from "./importations.vue?vue&type=script&lang=js&"
import style0 from "./importations.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports